import { render, staticRenderFns } from "./proceedingsMainAgenda.vue?vue&type=template&id=7b690eb1"
import script from "./proceedingsMainAgenda.vue?vue&type=script&lang=js"
export * from "./proceedingsMainAgenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b690eb1')) {
      api.createRecord('7b690eb1', component.options)
    } else {
      api.reload('7b690eb1', component.options)
    }
    module.hot.accept("./proceedingsMainAgenda.vue?vue&type=template&id=7b690eb1", function () {
      api.rerender('7b690eb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/osh/proceedingsMainAgenda.vue"
export default component.exports